import React from "react";
import { ItemsList } from "./ItemsList";
import { makeStyles, Paper, Typography } from "@material-ui/core";
import { LinkModel } from "../../domain/LinkModel";
import mydata from '../../services/json/links.json'
import { AppBar } from "@ofqual/portal-components/components/SecondaryAppBar";
import { MODULE_NAME } from "../../moduleName";
const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const Items: React.FC = () => {

  const responseArray = JSON.stringify(mydata);
  const items = JSON.parse(responseArray) as LinkModel[];
  items.sort((a, b) => Number(a.categoryId) - Number(b.categoryId));



  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar moduleName={MODULE_NAME} breadcrumbs={[{ label: "Home / Useful links", to: '' }]} />
      <div>
        <Paper>
          <Typography variant="h2" component="div">
            Useful Links
          </Typography>

          <ItemsList items={items} />
        </Paper>
      </div>
    </div>
  );
};
